<template>
  <div class="home">
    <div class="header">
      <div class="header-texts">
        <h1>Референции от</h1>
        <h1>нашите клиенти</h1>
        <div class="row">
          <div class="header-ps">
            <!-- <p>Създаваме програми за управление на производство, машини и съоръжения. Системите ни изчисляват натовареността на персонала, калкулират заработки, надници и капацитет на машини и служители.</p> -->
          </div>
        </div>
      </div>
      <img class="header-img" src="/static/img/home/header2.webp" alt="Preview" />
    </div>
    <div class="solutions" id="solutions">
      <div class="solutions-header">
        <h6 @click="isMenuHidden = false">
          НАШИТЕ КЛИЕНТИ
          <svg
            class="arrow"
            :class="{ 'arrow-rotated' : !isMenuHidden }"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 59.4 59.4"
            style="enable-background:new 0 0 59.4 59.4;"
            xml:space="preserve"
          >
            <g>
              <polygon points="29.7,45.3 0,15.6 1.4,14.1 29.7,42.4 58,14.1 59.4,15.6 	" />
            </g>
          </svg>
        </h6>
        <div class="solutions-header-content">
          <router-link
            to="/clients/business-big"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'business-big', 'solutions-header-item-hidden' : isMenuHidden }"
          >Голям бизнес</router-link>
          <router-link
            to="/clients/business-small"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'business-small', 'solutions-header-item-hidden' : isMenuHidden }"
          >Среден бизнес</router-link>
          <router-link
            to="/clients/npo"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'npo', 'solutions-header-item-hidden' : isMenuHidden }"
          >НПО</router-link>
          <router-link
            to="/clients/admin"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'admin', 'solutions-header-item-hidden' : isMenuHidden }"
          >Администрация</router-link>
          <router-link
            to="/clients/other-clients"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'other-clients', 'solutions-header-item-hidden' : isMenuHidden }"
          >Други</router-link>
        </div>
      </div>
      <div class="solutions-content" v-if="solutions.length">
        <a
          class="solutions-item"
          v-for="(solution, index) in solutions"
          :key="'solution-' + index"
          :href="solution.url ? `/static/pdf/${solution.url}` : null"
          :target="solution.url ? '_blank' : null"
        >
          <img class="solutions-item-img" :src="solution.imageOne" alt="Image" />
          <p class="solutions-item-description">{{solution.name}}</p>
          <span class="solutions-item-name" v-if="solution.company">{{solution.company}}</span>
        </a>
      </div>
      <div
        class="solutions-content"
        v-else-if="!solutions.length && this.$route.params.category === 'e-commerce'"
      >
        <div class="solutions-content-itemless">
          <img src="/static/img/solutions/6.png" alt="E-Commerce" />
          <div class="solutions-content-itemless-texts">
            <p>Е-магазин за къмпингово оборудване и свързаните с това продукти, интеграция на всички видове плащания, включително лизинг на оборудване.</p>
            <p>Е-магазин за едра и дребна бяла техника, електроника за няколко държави – България, Гърция, Словения, Македония. Системата е интегрирана и се управлява от едно място, централизирано.</p>
            <p>Е-магазин за бетонови елементи – при поръчка изчислява стойността на доставката за клиента, на поръчаните елементи.</p>
          </div>
        </div>
      </div>
      <div
        class="solutions-content"
        v-else-if="!solutions.length && this.$route.params.category === 'integration'"
      >
        <div class="solutions-content-itemless">
          <img src="/static/img/solutions/cd2.png" alt="cDots" />
          <div class="solutions-content-itemless-texts">
            <p><strong>Интеграции с външни системи</strong></p>
            <p>➡️ Интеграция на вътрешни системи – Комуникационна инфраструктура (мейл, чат, календари, споделени работни пространства), клауд решение за управление и споделяне на файлове, хелпдеск система.</p>
            <p>Клауд базирани системи - за различни бизнес решения</p>
            <p>Интеграция на ERP система с модул за мобилни продажби</p>
            <p>Интеграция на ERP система с е-магазин</p>
            <p>Интеграция на ERP система с решение за справки (reporting tool)</p>
            <p>Интеграция на мобилни приложения с вътрешни системи (GPS проследяване и други)</p>
          </div>
        </div>
      </div>
      <div
        class="solutions-content"
        v-else-if="!solutions.length && this.$route.params.category === 'others'"
      >
      </div>
      <div class="solutions-content" v-else>
        <p class="no-solutions">Няма клиенти в избраната категория</p>
      </div>
    </div>
    <Consultation />
    <transition name="fade">
      <Modal v-if="isModalOpened" :video="'https://www.youtube.com/embed/9lgpbgo4GdM'" />
    </transition>
  </div>
</template>

<script>
import Clients from '../assets/clients.json';
import Consultation from './Consultation';
import Modal from './shared/Modal';
export default {
  components: {
    Consultation: Consultation,
    Modal: Modal
  },
  data() {
    return {
      solutions: Clients,
      isMenuHidden: true,
      isModalOpened: false
    };
  },
  watch: {
    $route(to, from) {
      this.filterSolutions();
      this.isMenuHidden = true;
    }
  },
  methods: {
    filterSolutions() {
      if (this.$route.params.category) {
        const category = this.$route.params.category;
        this.solutions = Clients.filter(o => {
          return o.category === category;
        });
      } else {
        this.solutions = Clients
      }
    }
  },
  mounted() {
    this.filterSolutions();
    this.$on('close-modal', () => (this.isModalOpened = false));
  },
  destroyed() {
    this.$off('close-modal');
  }
};
</script>

<style scoped>
.home {
  overflow: hidden;
}
/* HEADER */
.header {
  align-items: center;
  display: flex;
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 40px;
  position: relative;
  width: 100%;
}
.header-texts {
  width: 70%;
}
.row {
  display: flex;
  width: 90%;
}
.header-texts > h1:last-of-type {
  margin-bottom: 30px;
}
.header-ps {
  width: 50%;
}
.header-ps > p {
  margin-bottom: 15px;
  /* width: 90%; */
}
.header-ps > p:last-child {
  margin-bottom: 0;
}
.header-img {
  max-width: 1000px;
  position: absolute;
  right: -10%;
  top: 50px;
  width: 50%;
  z-index: -1;
}
/* SOLUTIONS */
.solutions {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.solutions-header > h6 {
  font-weight: 500;
  margin: 30px 0;
  text-align: center;
}
.solutions-header-content {
  display: flex;
}
.solutions-header-item {
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 4px;
  color: #3f3f3f;
  cursor: pointer;
  display: inline-flex;
  height: 90px;
  justify-content: center;
  margin-right: 20px;
  padding: 20px;
  text-align: center;
  width: 160px;
}
.solutions-header-item:last-of-type {
  margin: 0;
}
.solutions-header-item:hover {
  background-color: #ebebeb;
}
.solutions-header-item-active {
  background-color: #d9d9d9;
}
.inactive {
  cursor: default;
}
.inactive:hover {
  background-color: #f8f8f8;
}
/* SOLUTION ITEMS */
.solutions-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 75px 0;
  width: 1300px;
}
.solutions-item {
  flex-basis: calc(33.33% - 30px);
  /* width: 400px;
  margin-right: 50px; */
  margin-bottom: 40px;
}
.solutions-item:hover {
  mix-blend-mode: luminosity;
}
.solutions-item:nth-of-type(3n) {
  margin-right: 0;
}
.solutions-item-img {
  border-radius: 15px;
  width: 100%;
}
.solutions-item-description {
  color: #000;
  margin: 15px 0 5px;
}
.solutions-item-name {
  color: #929292;
  font-size: 14px;
}
.solutions-content-itemless {
  align-items: center;
  display: flex;
}
.solutions-content-itemless img {
  margin-right: 3%;
  width: 37%;
}
.solutions-content-itemless-texts {
  margin-left: 3%;
  width: 57%;
}
.solutions-content-itemless-texts p {
  margin-bottom: 15px;
}
.no-solutions {
  opacity: 0.6;
  text-align: center;
  width: 100%;
}
.arrow {
  display: none;
}
/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .header-texts > h1:last-of-type {
    margin-bottom: 25px;
  }
  .solutions-header-item {
    font-size: 14px;
    width: 150px;
  }
  .solutions-header-content {
    width: 1200px;
  }
  .solutions-content {
    padding: 60px 0;
    width: 1120px;
  }
  /* .solutions-item {
    width: 340px;
  } */
  .header-ps {
    width: 60%;
  }
}
@media screen and (max-width: 1440px) {
  .header {
    padding: 30px 100px;
  }
  .header-texts > h1:last-of-type {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 1366px) {
  .solutions-header > h6 {
    margin: 25px 0;
  }
  .solutions-header-item {
    font-size: 12px;
    height: 75px;
    width: 150px;
  }
  .solutions-header-content {
    width: 1100px;
  }
  .solutions-content {
    padding: 40px 0;
    width: 1000px;
  }
  /* .solutions-item {
    width: 300px;
  } */
  .solutions-item-description {
    font-size: 13px;
    margin: 10px 0 0px;
  }
  .solutions-item-name {
    font-size: 12px;
  }
}
@media screen and (max-width: 1280px) {
  .header-img {
    display: none;
  }
  .header {
    padding: 20px;
  }
  .row {
    align-items: center;
    flex-direction: column-reverse;
    width: 100%;
  }
  .header-texts {
    width: 100%;
  }
  .header-texts h1 {
    text-align: center;
  }
  .header-ps {
    width: 100%;
  }
  .header-ps p {
    text-align: center;
    width: 100%;
  }
  .header-texts > h1:last-of-type {
    margin-bottom: 10px;
  }
  .solutions-header {
    width: 100%;
    padding: 0 20px;
  }
  .solutions-header-content {
    width: 100%;
  }
  .solutions-header-item {
    width: 12.5%;
  }
  .solutions-content {
    padding: 20px;
    width: 100%;
  }
  .solutions-item {
   flex-basis: calc(33.33% - 13.33px);
     /* margin-right: 20px; */
  }
}
@media screen and (max-width: 1000px) {
  .solutions {
    padding-bottom: 63px;
  }
  .solutions-header-content {
    flex-wrap: wrap;
  }
  .solutions-header-item {
    height: 50px;
    margin-right: 20px;
    width: calc(25% - 15px);
  }
  .solutions-header-item:nth-child(4n) {
    margin-right: 0;
  }
  .solutions-header-item:nth-child(n + 5) {
    margin-top: 20px;
  }
  .solutions-content {
    padding: 20px 40px;
  }
  .solutions-content-itemless {
    flex-direction: column;
  }
  .solutions-content-itemless img {
    width: 60%;
    margin: 0 0 15px;
  }
  .solutions-content-itemless-texts {
    margin: 15px 0 0;
    width: 100%;
  }
  .solutions-content-itemless-texts p {
    text-align: center;
  }
}
@media screen and (max-width: 800px) {
  .header {
    padding-top: 0;
  }
  .solutions-item {
    margin-bottom: 20px;
    flex-basis: calc(50% - 10px);
  }
  .solutions-item:hover {
    transform: initial;
  }
  .solutions-item:nth-of-type(3n) {
    margin-right: 20px;
  }
  .solutions-item:nth-of-type(2n) {
    margin-right: 0;
  }
}
@media screen and (max-width: 600px) {
  .solutions {
    padding-bottom: 50px;
  }
  .solutions-header > h6 {
    cursor: pointer;
    margin: 0;
    padding: 25px;
  }
  .solutions-header-item {
    margin: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }
  .solutions-header-item:nth-child(n + 5) {
    margin: 0;
  }
  .solutions-header-item-hidden {
    height: 0px;
    padding: 0;
  }
  .solutions-item {
    flex-basis: 100%;
    margin: 0 0 20px;
  }
  .solutions-item:nth-of-type(3n) {
    margin-right: 0;
  }
  .solutions-content {
    padding: 20px;
  }
  .solutions-header > h6 {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .arrow {
    display: inline-block;
    height: 16px;
    margin-left: 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 16px;
  }
  .arrow-rotated {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Clients.vue